import { cva } from "class-variance-authority";

export const buttonVariants = cva(
  [
    "inline-flex items-center justify-start",
    "border-2 border-solid border-transparent",
    "transition-colors duration-300 ease-out",
    "disabled:pointer-events-none disabled:transition-none",
    "cursor-pointer disabled:cursor-default",
  ],
  {
    defaultVariants: {
      size: "large",
      variant: "primary",
    },
    variants: {
      size: {
        large: "h-11 gap-2 rounded-md px-4 py-0.5",
        medium: "h-8 gap-1 rounded-md px-2 py-0.5",
        small: "h-5 gap-1 rounded-sm px-2 py-0.5 border",
      },
      variant: {
        primary: [
          "bg-primary text-primary-foreground",
          "hover:bg-primary/85",
          "active:bg-primary",
          "disabled:bg-primary/50",
        ],
        secondary: [
          "bg-transparent text-primary border-primary",
          "hover:bg-primary/10",
          "active:bg-transparent",
          "disabled:bg-transparent disabled:border-primary/50 disabled:text-primary/50",
        ],
        text: [
          "bg-transparent text-primary border-transparent",
          "hover:bg-primary/10",
          "active:bg-transparent",
          "disabled:bg-transparent disabled:text-primary/50",
        ],
      },
    },
  },
);

export const prefixSuffixVariants = cva("flex items-center justify-center *:max-h-[inherit] *:max-w-[inherit]", {
  defaultVariants: {
    size: "large",
  },
  variants: {
    size: {
      large: "max-h-6 max-w-6 text-[24px]",
      medium: "max-h-5 max-w-5 text-[20px]",
      small: "max-h-3 max-w-3 text-[12px]",
    },
  },
});
